/**
 * @flow
 * @relayHash 7929c855b5c60eb8658d86fcb091118b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountRecheckPage_viewer$ref = any;
export type AccountRecheckPageQueryRendererQueryVariables = {|
  eventId: string,
  count: number,
  cursor?: ?string,
  isRecheckPage: boolean,
|};
export type AccountRecheckPageQueryRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AccountRecheckPage_viewer$ref
  |}
|};
export type AccountRecheckPageQueryRendererQuery = {|
  variables: AccountRecheckPageQueryRendererQueryVariables,
  response: AccountRecheckPageQueryRendererQueryResponse,
|};
*/


/*
query AccountRecheckPageQueryRendererQuery(
  $eventId: ID!
  $count: Int!
  $cursor: String
  $isRecheckPage: Boolean!
) {
  viewer {
    ...AccountRecheckPage_viewer
    id
  }
}

fragment AccountRecheckPage_viewer on Viewer {
  event(id: $eventId) {
    mainSearch
    ...RecheckMediaList_impressionMediaData
    ...RecheckMediaList_offer
    id
  }
  account {
    rechecks(eventId: $eventId) {
      startnumber
      requestedAt
      media {
        ...RecheckMediaList_recheckMedia
      }
    }
    ...RecheckMediaList_account
    id
  }
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  recheckStatus
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      recheckStatus
      recheckRequestedAt @include(if: $isRecheckPage)
      ...MediaListItem_item
    }
  }
}

fragment MediaList_offer on Event {
  products {
    id
    mediaCollection {
      name
      id
    }
    price
    type
  }
  voucherCampaigns {
    id
    banner
    name
    shortText
  }
}

fragment RecheckMediaList_account on Account {
  eventPurchases(eventId: $eventId) {
    availableZips
  }
}

fragment RecheckMediaList_impressionMediaData on Event {
  impressionMedia {
    mediaInfo {
      count
    }
  }
}

fragment RecheckMediaList_offer on Event {
  ...MediaList_offer
}

fragment RecheckMediaList_recheckMedia on ExtendedMediaConnection {
  mediaList(first: $count, after: $cursor) {
    edges {
      node {
        recheckStatus
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    ...MediaList_media
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isRecheckPage",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AccountRecheckPageQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AccountRecheckPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AccountRecheckPageQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "eventId"
              }
            ],
            "concreteType": "Event",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "mainSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "impressionMedia",
                "storageKey": null,
                "args": null,
                "concreteType": "ExtendedMediaConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "count",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "products",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaCollection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaCollection",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v1/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "voucherCampaigns",
                "storageKey": null,
                "args": null,
                "concreteType": "VoucherCampaign",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "banner",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shortText",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "account",
            "storageKey": null,
            "args": null,
            "concreteType": "Account",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "rechecks",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Recheck",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startnumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "requestedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "media",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mediaList",
                        "storageKey": null,
                        "args": (v4/*: any*/),
                        "concreteType": "MediaConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Media",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "recheckStatus",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v1/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sgId",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shotDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "variants",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaFile",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "url",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isRecheckPage",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "recheckRequestedAt",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "mediaList",
                        "args": (v4/*: any*/),
                        "handle": "connection",
                        "key": "RecheckMediaList_mediaList",
                        "filters": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "eventPurchases",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "EventPurchases",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableZips",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "AccountRecheckPageQueryRendererQuery",
    "id": null,
    "text": "query AccountRecheckPageQueryRendererQuery(\n  $eventId: ID!\n  $count: Int!\n  $cursor: String\n  $isRecheckPage: Boolean!\n) {\n  viewer {\n    ...AccountRecheckPage_viewer\n    id\n  }\n}\n\nfragment AccountRecheckPage_viewer on Viewer {\n  event(id: $eventId) {\n    mainSearch\n    ...RecheckMediaList_impressionMediaData\n    ...RecheckMediaList_offer\n    id\n  }\n  account {\n    rechecks(eventId: $eventId) {\n      startnumber\n      requestedAt\n      media {\n        ...RecheckMediaList_recheckMedia\n      }\n    }\n    ...RecheckMediaList_account\n    id\n  }\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  recheckStatus\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      recheckStatus\n      recheckRequestedAt @include(if: $isRecheckPage)\n      ...MediaListItem_item\n    }\n  }\n}\n\nfragment MediaList_offer on Event {\n  products {\n    id\n    mediaCollection {\n      name\n      id\n    }\n    price\n    type\n  }\n  voucherCampaigns {\n    id\n    banner\n    name\n    shortText\n  }\n}\n\nfragment RecheckMediaList_account on Account {\n  eventPurchases(eventId: $eventId) {\n    availableZips\n  }\n}\n\nfragment RecheckMediaList_impressionMediaData on Event {\n  impressionMedia {\n    mediaInfo {\n      count\n    }\n  }\n}\n\nfragment RecheckMediaList_offer on Event {\n  ...MediaList_offer\n}\n\nfragment RecheckMediaList_recheckMedia on ExtendedMediaConnection {\n  mediaList(first: $count, after: $cursor) {\n    edges {\n      node {\n        recheckStatus\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    ...MediaList_media\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b79cce8e0a8e3abc99ad1e6dbafc3fd';

module.exports = node;
